import styled from "styled-components";

export const Header = styled.header`
  display: flex;
  justify-content: space-between;
  width: 100%;
  justify-content: center;
  height: 5rem;
  div {
    display: flex;
    flex-direction: column;

    width: 50%;
    &:last-child {
      justify-content: center;
      align-items: flex-end;
      img {
        position: relative;
        height: 20px;
        width: 20px;
        right: 5px;
        bottom: 40%;
      }
      input {
        background: #edf4f6;
        color: #101e8e;
        height: 50%;
        padding: 0.5rem;
        accent-color: #101e8e;
        width: 80%;
      }
    }
  }
`;

export const TableSection = styled.section`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: flex-end;
  gap: 0.5rem;
`;

export const Numbers = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 35px;
  height: 35px;
  border: 1px solid #c1c9e1;
  background: #edf4f6;
  &.selectedNum {
    background: #fff;
    border: 1px solid #101e8e;
  }
`;

export const PopupData = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  span {
    font-size: 0.8rem;
    &:first-child {
      font-weight: bold;
      max-width: 50%;
    }
    &:last-child {
      width: 60%;
    }
  }
`;

export const SummaryTable = styled.table`
  width: 100%;
  
  
`;

export const LabelDiv = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  img {
    height: 25px;
    width: 25px;
    position: relative;
    left: 89%;
    bottom: 37px;
  }
`;

export const InputsContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  label{
    width: 100%;
  }
`;
